import { createContext, ReactNode, useContext } from 'react';
import type { ActivityDefinition, Coding } from '@medplum/fhirtypes';

export interface SchedulingPageContextValue {
  appointmentTypeCodings: Coding[];
  getActivityDefinitionForAppointmentType: (code: string | undefined) => ActivityDefinition | undefined;
}

const SchedulingPageContext = createContext<SchedulingPageContextValue | undefined>(undefined);

interface SchedulingPageProviderProps {
  value: SchedulingPageContextValue;
  children: ReactNode;
}

export function SchedulingPageProvider({ value, children }: SchedulingPageProviderProps) {
  return <SchedulingPageContext.Provider value={value}>{children}</SchedulingPageContext.Provider>;
}

export function useSchedulingPageContext(): SchedulingPageContextValue {
  const context = useContext(SchedulingPageContext);
  if (!context) {
    throw new Error('useSchedulingPageContext must be used within a SchedulingPageProvider');
  }
  return context;
}
